import { BASE_ALBUM_URL, BASE_ALBUM_ID_URL } from '@/constants/API'

export const LOAD_ALBUM = 'LOAD_ALBUM'
export const LOAD_ALBUM_ASYNC = 'LOAD_ALBUM_ASYNC'
export const LOAD_ALBUM_ITEM = 'LOAD_ALBUM_ITEM'
export const LOAD_ALBUM_ITEM_ASYNC = 'LOAD_ALBUM_ITEM_ASYNC'
export const CLEAR_ALBUM = 'CLEAR_ALBUM'

const album = {
  state: {
    docs: [],
    doc: null
  },
  getters: {
    albumCount: state => state.docs.length,
    getAlbum: state => state.docs,
    getAlbumItem: state => state.doc,
    getAlbumId: state => {
      if (state.doc) {
        return state.doc._id
      }
    },
    getAllAlbum: state => number => {
      if (number === null) {
        return state.docs
      }
      state.docs.forEach(v => {
        console.log(`getAllAlbum ${v._id}`)
      })
      return state.docs
    },
    getAlbumTitleByPostId: state => id => state.docs.find(doc => doc._id === id).title,
    // eslint-disable-next-line no-unused-vars
    getAlbumData: (state, getters) => {
      const { doc } = state
      if (doc) {
        doc.items.forEach(v => {
          v.thumb = v.first.url
          v.alt = v.first.description
        })
        return {
          ...doc,
          data: doc.items
        }
      }
      return null
    }
  },
  actions: {
    /* 按照id获取一篇文章 */
    [LOAD_ALBUM_ITEM_ASYNC]({ commit }, payload) {
      return new Promise((resolve, reject) => {
        this._vm.$axios({
          commit,
          url: `${BASE_ALBUM_ID_URL}${payload.id}`,
          doHideAlert: true,
          success(result) {
            // 保存文章
            commit(LOAD_ALBUM_ITEM, result.doc)
            // 向前端通知操作成功
            resolve(result.doc)
          },
          fail(err) {
            // 向前端通知操作失败
            reject(err)
          }
        })
      })
    },
    /* 获取所有文章 */
    [LOAD_ALBUM_ASYNC]({ commit }) {
      return new Promise((resolve, reject) => {
        this._vm.$axios({
          commit,
          url: `${BASE_ALBUM_URL}`,
          doHideAlert: true,
          success(result) {
            // 保存文章
            commit(LOAD_ALBUM, result.docs)
            // 向前端通知操作成功
            resolve(result.docs)
          },
          fail(err) {
            // 向前端通知操作失败
            reject(err)
          }
        })
      })
    }
  },
  mutations: {
    /* 保存所有文章信息 */
    [LOAD_ALBUM](state, payload) {
      state.docs = payload
    },
    /* 保存当前文章信息 */
    [LOAD_ALBUM_ITEM](state, payload) {
      state.doc = payload
    },
    /* 清空当前文章信息 */
    [CLEAR_ALBUM](state) {
      state.doc = null
    }
  }
}
export default album



// WEBPACK FOOTER //
// ./src/components/Album/module.js